import hljs from "highlight.js/lib/core";
import cpp from "highlight.js/lib/languages/cpp";
import "highlight.js/styles/atom-one-light.css";
hljs.registerLanguage("cpp", cpp);
function addLineNumbers(codeEl) {
  const code = codeEl.innerHTML;
  const lines = code.split("\n");
  const maxLineNumberLength = String(lines.length).length;
  const numberedCode = lines
    .map((line, index) => {
      const lineNumber = index + 1;
      return `<span class="line-number">${lineNumber}</span>: <span class="code-line">${line}</span>`;
    })
    .join("\n");
  codeEl.innerHTML = numberedCode;
}

export default {
  install(Vue, options) {
    Vue.directive("highlight", {
      deep: true,
      bind: function (el, binding) {
        Array.from(el.querySelectorAll("code")).forEach((target) => {
          if (binding.value) {
            target.textContent = binding.value;
          }
          hljs.highlightBlock(target);
          addLineNumbers(target);
          target.dataset.highlighted = "true";
        });
      },
      componentUpdated: function (el, binding) {
        Array.from(el.querySelectorAll("code")).forEach((target) => {
          if (binding.value) {
            target.textContent = binding.value;
          }
          if (target.dataset.highlighted) {
            delete target.dataset.highlighted;
          }
          hljs.highlightBlock(target);
          addLineNumbers(target);
          target.dataset.highlighted = "true";
        });
      },
    });
  },
};
